import alert from './alert';
import Modal from './Modal';
import operation from './operation';
import prompt from './prompt';
Modal.alert = alert;
Modal.prompt = prompt;
Modal.operation = operation;
export default Modal;



// WEBPACK FOOTER //
// ./components/modal/index.tsx